import SortOrder from '~/client/src/shared/enums/SortOrder'
import { compareLabelsAlphanumeric } from '~/client/src/shared/utils/compareGroupsByLabel'

import { isEmptyValue } from './emptiness'
import type { ListSchema } from './schema'
import { getField } from './schema'

export function compareEmptyLast(left: unknown, right: unknown): number {
  const leftEmpty = isEmptyValue(left)
  const rightEmpty = isEmptyValue(right)

  if (leftEmpty && rightEmpty) return 0
  if (leftEmpty) return 1
  if (rightEmpty) return -1

  if (typeof left === 'number' && typeof right === 'number') {
    return left - right
  }

  return compareLabelsAlphanumeric(String(left), String(right))
}

export function sortRecords<T>(
  records: readonly T[],
  schema: ListSchema<T>,
  sortKey: string | null,
  sortOrder: SortOrder,
): readonly T[] {
  if (!sortKey || sortOrder === SortOrder.DEFAULT) return records

  const field = getField(schema, sortKey)
  if (!field?.sortable) return records

  const sortValue = field.sortValue ?? field.value
  const direction = sortOrder === SortOrder.DESC ? -1 : 1

  return [...records].sort((left, right) => {
    const l = sortValue(left)
    const r = sortValue(right)
    const comparison = compareEmptyLast(l, r)
    if (isEmptyValue(l) || isEmptyValue(r)) {
      return comparison
    }
    return comparison * direction
  })
}
